import React, {createContext, useState} from 'react';
import PropTypes from 'prop-types';

export const RequestContext = createContext({});

export const Provider = (props) => {
  const {children} = props;

  const [selectedRequest, setSelectedRequest] = useState(null);
  const [reloading, setReloading] = useState(false);
  const [editing, setEditing] = useState(false);

  const requestContext = {
    selectedRequest,
    setSelectedRequest,
    reloading,
    setReloading,
    editing,
    setEditing,
  };

  return (
    <RequestContext.Provider value={requestContext}>
      {children}
    </RequestContext.Provider>
  );
};

export const {Consumer} = RequestContext;

Provider.propTypes = {
  children: PropTypes.any,
};
